import Banner from "../../sections/common/banner";
import SectionServices from "../../sections/services/maritime-law-service/section-services";
import { data as dataEs } from "../../../globals/data/es/derechoMaritimoService.js";
import { data as dataEn } from "../../../globals/data/en/derechoMaritimoService.js";
import { data as dataCn } from "../../../globals/data/zh/derechoMaritimoService.js";
import { useLangagesStore } from "../../../context/langages";

export default function MaritimeLawService() {
    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEn : language === "cn" ? dataCn : dataEs;

    return (
        <>
            <Banner _data={data.banner} />
            <SectionServices _data={data.features} />
        </>
    )
}